import * as adminService from '@/services/admin'

const DEFAULT_PAGINATION = {
  current: 1,
  pageSize: 25,
  pageSizeOptions: ['10', '25', '35', '45', '100'],
  showQuickJumper: true,
  showSizeChanger: true,
}
const DEFAULT_FILTERS = null
const DEFAULT_SORTER = { field: 'created_at', order: 'descend' }
const DEFAULT_QUERY = {
  pagination: DEFAULT_PAGINATION,
  filters: DEFAULT_FILTERS,
  sorter: DEFAULT_SORTER,
}
const DEFAULT_META = {
  total: 25,
}

export default {
  namespaced: true,
  state: {
    contractor: null,
    contractors: null,
    query: DEFAULT_QUERY,
    meta: DEFAULT_META,
    loading: false,
  },

  getters: {
    loading: (state) => state.loading,
    contractor: (state) => state.contractor,
    contractors: (state) => state.contractors,
    query: (state) => state.query,
    pagination: (state) => state.query.pagination,
    filters: (state) => state.query.filters,
    sorter: (state) => state.query.sorter,
    meta: (state) => state.meta,
  },

  mutations: {
    INIT: (state) => {
      state.loading = false
      state.query = DEFAULT_QUERY
      state.meta = DEFAULT_META
    },

    // contractor
    SET_CONTRACTOR: (state, contractor) => {
      state.contractor = contractor
    },
    // contractors
    SET_CONTRACTORS: (state, contractors) => {
      state.contractors = contractors
    },
    SET_PAGINATION: (state, pagination) => {
      state.query.pagination = pagination
    },
    SET_FILTERS: (state, filters) => {
      state.query.filters = filters
    },
    SET_SORTER: (state, sorter) => {
      const { field, order } = sorter
      state.query.sorter = { field, order }
    },
    SET_CONTRACTORS_META: (state, meta) => {
      state.meta = meta
      if (meta.total) state.query.pagination.total = meta.total
    },
    START_LOADING: (state) => {
      state.loading = true
    },
    END_LOADING: (state) => {
      state.loading = false
    },
  },
  actions: {
    // initialization
    async init({ commit, dispatch }) {
      commit('INIT')
    },

    // set pagination
    setPagination({ commit }, pagination) {
      if (pagination && pagination.current) commit('SET_PAGINATION', pagination)
    },
    // set filters
    setFilters({ commit }, filters) {
      if (filters && Object.keys(filters).length) commit('SET_FILTERS', filters)
    },
    // set sorter
    setSorter({ commit }, sorter) {
      if (sorter && sorter.field) commit('SET_SORTER', sorter)
    },
    // set all query same time
    setQuery({ dispatch }, { pagination, filters, sorter }) {
      dispatch('setPagination', pagination)
      dispatch('setFilters', filters)
      dispatch('setSorter', sorter)
      dispatch('fetchContractors')
    },

    // * DATA HANDLING
    // fetch contractor by id
    async fetchContractor({ commit }, id) {
      commit('START_LOADING')
      if (id) {
        const contractor = await adminService.fetchContractor(id)
        if (contractor) commit('SET_CONTRACTOR', contractor)
        return contractor
      }
      commit('END_LOADING')
    },

    // fetch all contractors
    async fetchContractors({ state, commit }) {
      commit('START_LOADING')
      const { contractors, meta } = await adminService.fetchContractors(state.query)
      if (contractors) commit('SET_CONTRACTORS', contractors)
      if (meta) commit('SET_CONTRACTORS_META', meta)
      commit('END_LOADING')

      return state.contractors
    },

    // create contractor
    async createContractor({ commit }, contractor) {
      let contractor_created = null
      commit('START_LOADING')
      if (contractor) {
        contractor_created = await adminService.createContractor(contractor)
        if (contractor_created) commit('SET_CONTRACTOR', contractor_created)
        return contractor_created
      }
      commit('END_LOADING')
      return contractor_created
    },

    // update contractor
    async updateContractor({ commit }, contractor) {
      let contractor_updated = null
      commit('START_LOADING')
      if (contractor) {
        contractor_updated = await adminService.updateContractor(contractor)
        if (contractor_updated) commit('SET_CONTRACTOR', contractor_updated)
      }
      commit('END_LOADING')
      return contractor_updated
    },
  },
}
